import { Compatibility, EntityCode } from '../api/octopus';
import { ColumnWithTranslation } from './columns';

// Marks a column that shows a field: it sorts by its cell's SortValue and its id stays apart
// from the row model's own properties.
export const fieldColumnPrefix = 'field:';

export interface ColumnSetupField {
  id: string;
  name: string;
  removable: boolean;
}

export interface ColumnView {
  key: string | null;
  rank: number;
  columns: ColumnWithTranslation[];
}

export interface ColumnViewLoad {
  view: ColumnView;
  savable: boolean;
  error?: Error;
  removedColumns?: ColumnWithTranslation[];
}

export interface ColumnFieldEntity {
  entity: EntityCode;
  compatibility?: Compatibility;
}
